import { Pagination as MuiPagination, PaginationItem, styled } from "@mui/material";

export interface PaginationProps {
  page?: number;
  pages?: number;
  onChange?: (page: number) => void;
}
export default function Pagination(props: PaginationProps) {
  const { onChange, page, pages } = props;

  return (
    <MuiPagination
      shape="rounded"
      count={pages}
      renderItem={(item) => <Btn active={item.selected} {...item} />}
      onChange={(e, val) => onChange && onChange(val)}
      defaultPage={page}
      sx={{
        ".MuiPagination-ul": {
          flexWrap: "nowrap",
        },
      }}
    />
  );
}
const Btn = styled(PaginationItem)(({ active }: { active?: boolean }) => ({
  color: "#95A3B5",
  borderRadius: 4,
  ...(active && {
    backgroundColor: "transparent !important",
    border: "1px solid #1062D0",
    color: "#1062D0",
  }),
  "&:hover": {
    backgroundColor: "#E9F2FF",
    color: "#1062D0",
  },
}));
